module.exports = __webpack_public_path__ + "static/media/odontopodisma_decipiens.e32f343b.jpg";